<template>
  <div id="quiz-permission">
    <b-form @submit.prevent="submitForm">
      <b-card no-body class="p-2 container-card mb-1">
        <b-col lg="6" md="8">
          <setting-permission
            :formData="permissionForm"
            :tagOption="tagOption"
            :value="TAG_ADD"
            @onInputSelectTag="selectedTagPer"
            @onInputDuplicateTag="checkDuplicateTag"
            :isDisabled="permissionForm.isComplete"
          />
        </b-col>
      </b-card>

      <b-card no-body class="p-2 container-card mb-1">
        <b-col md="8">
          <div class="mb-2 custom-ml">
            <span class="mb-1 permission-header"
              >กำหนดจำนวนผู้ที่สามารถเล่นเกมนี้ได้</span
            >

            <div class="d-flex align-items-center">
              <b-row class="pl-1 mt-1">
                <b-form-checkbox
                  v-model="permissionForm.numberPlayers"
                  class="mr-0 custom-control-success"
                  name="is-rtl"
                  :value="false"
                  :unchecked-value="true"
                  switch
                  inline
                  @input="changeIsLimit(permissionForm.numberPlayers)"
                />
                <b-col class="ml-2"
                  ><b-row class="text-black font-medium-3"
                    ><b>ไม่จำกัดจำนวนผู้เล่น</b></b-row
                  >
                  <b-row class="text-black font-medium-3"
                    >เปิดให้ผู้เล่นสามารถใช้งานได้ไม่จำกัดจำนวน</b-row
                  >
                </b-col>
              </b-row>
            </div>
            <div class="d-flex align-items-center">
              <b-col cols="12" class="pl-0">
                <b-row class="pl-1 mt-1">
                  <b-form-checkbox
                    v-model="permissionForm.numberPlayers"
                    class="mr-0 custom-control-success"
                    name="is-rtl"
                    :value="true"
                    switch
                    inline
                  />

                  <b-col class="ml-2">
                    <b-row
                      class="text-black font-medium-3 font-medium-3 d-flex justify-content-between"
                      ><div><b>จำกัดจำนวนการใช้งาน</b></div>
                      <div
                        class="d-flex align-items-center justify-content-end"
                      >
                        <input-spin-quiz
                          :isDisabled="permissionForm.numberPlayers == false"
                          :numValue="permissionForm.usageLimit"
                          :isInputDisabled="false"
                          @update-number="updateUsageLimit"
                        />
                      </div>
                    </b-row>
                    <b-row class="text-black font-medium-3"
                      >เปิดให้ผู้เล่นสามารถใช้งานได้จำกัดจำนวน</b-row
                    >
                  </b-col>
                </b-row>
              </b-col>
            </div>
          </div>
        </b-col>
      </b-card>

      <b-row>
        <b-col cols="12" class="d-flex justify-content-center flex-wrap mt-3">
          <cancel-button
            :btn-label="'Back'"
            @click.native="$emit('onPreviousStep')"
            class="mr-2"
            stageBack
          />
          <save-button :type="'submit'" :btn-label="'Next'" />
        </b-col>
      </b-row>
    </b-form>
  </div>
</template>

<script>
import usePermission from "../hooks/usePermission";
import InputSpinQuiz from "@/views/components/input-spin/InputSpinQuiz.vue";
import SettingPermission from "./privilege/SettingPermission.vue";

export default {
  components: {
    InputSpinQuiz,
    SettingPermission,
  },

  setup(props) {
    const {
      tagOption,
      permissionForm,
      TAG_ADD,
      updateUsageLimit,
      submitForm,
      selectedTagPer,
      checkDuplicateTag,
      changeIsLimit,
    } = usePermission(props);
    return {
      tagOption,
      permissionForm,
      TAG_ADD,
      updateUsageLimit,
      submitForm,
      selectedTagPer,
      checkDuplicateTag,
      changeIsLimit,
    };
  },
};
</script>

<style scoped>
@import "~@/assets/css/override-styles/tag-dropdown.css";
@import "~@/assets/css/pages/quiz/permission.css";
</style>

<style>
.custom-checkbox-players {
  margin-bottom: 5px;
}

#quiz-permission .btn-secondary:disabled {
  background-color: #c7cfce !important;
  border-color: #c7cfce !important;
}
</style>